import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['feedback']

  start() {
    this.show('Checking mailbox access…', 'text-ink-muted')
  }

  finish(event) {
    if (!event.detail.success && this.element.isConnected &&
        !event.detail.fetchResponse?.contentType?.startsWith('text/vnd.turbo-stream.html')) {
      this.failed()
    }
  }

  missing(event) {
    event.preventDefault()
    this.failed()
  }

  failed() {
    this.show('Mailbox access could not be checked. Please try again.', 'text-state-bad')
  }

  show(message, tone) {
    this.feedbackTarget.classList.remove('text-ink-muted', 'text-state-bad', 'text-state-ok')
    this.feedbackTarget.classList.add(tone)
    this.feedbackTarget.textContent = message
  }
}
